const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 6L6.83405 18.5107C6.8925 19.3875 6.92173 19.8259 7.1111 20.1583C7.27783 20.451 7.52931 20.6863 7.83241 20.8332C8.17668 21 8.61606 21 9.49481 21H14.5052C15.3839 21 15.8233 21 16.1676 20.8332C16.4707 20.6863 16.7222 20.451 16.8889 20.1583C17.0783 19.8259 17.1075 19.3875 17.166 18.5107L18 6",
    stroke: "#E12727",
    style: {
      stroke: "#E12727",
      stroke: "color(display-p3 0.8825 0.1537 0.1537)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6L20 6",
    stroke: "#E12727",
    style: {
      stroke: "#E12727",
      stroke: "color(display-p3 0.8825 0.1537 0.1537)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6L15.6078 4.82339C15.3892 4.16771 15.28 3.83987 15.0773 3.59748C14.8983 3.38345 14.6684 3.21777 14.4087 3.11565C14.1147 3 13.7691 3 13.078 3H10.922C10.2309 3 9.8853 3 9.59126 3.11565C9.3316 3.21777 9.10173 3.38345 8.92274 3.59748C8.72004 3.83987 8.61076 4.16771 8.3922 4.82339L8 6",
    stroke: "#E12727",
    style: {
      stroke: "#E12727",
      stroke: "color(display-p3 0.8825 0.1537 0.1537)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10V17",
    stroke: "#E12727",
    style: {
      stroke: "#E12727",
      stroke: "color(display-p3 0.8825 0.1537 0.1537)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10V17",
    stroke: "#E12727",
    style: {
      stroke: "#E12727",
      stroke: "color(display-p3 0.8825 0.1537 0.1537)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashAlt);
export default __webpack_public_path__ + "static/media/trash-alt.50e08a1d03c373d83646fb2e34bdd817.svg";
export { ForwardRef as ReactComponent };